import { getRequest } from './request.js';
import { getApiUrls } from './constants.js';
import toastr from 'toastr';


const closeModal = ()=> {
    const modalEl = document.getElementById('modal');
    modalEl.classList.toggle('modal--hidden');
};

export const handleTermsModal = ()=> {
    const modalButtonEl = document.getElementById('modal-button');
    const modalEl = document.getElementById('modal');
    const modalContentEl = document.getElementById('modal-content');
    const { SHIPAY_TERMS_URL } = getApiUrls();

    getRequest(SHIPAY_TERMS_URL).then((res)=> {
        modalContentEl.innerHTML = res;
        modalButtonEl.addEventListener('click', ()=> {
            modalEl.classList.toggle('modal--hidden');
        });
        modalContentEl.addEventListener('click', (e)=> {
            e.preventDefault();
            e.stopPropagation();
        });
        modalEl.addEventListener('click', ()=> {
            closeModal();
        });
    }).catch((err)=> {
        if(!err) {
            modalButtonEl.addEventListener('click', ()=> {
                modalEl.classList.toggle('modal--hidden');
            });
            modalContentEl.addEventListener('click', (e)=> {
                e.preventDefault();
                e.stopPropagation();
            });
            modalEl.addEventListener('click', ()=> {
                closeModal();
            });
        }
        toastr.error('Problema ao carregar Termos');
    });
};
